import { ReportsStore } from './reportsStore';

export const reportsStore = new ReportsStore();
